import { ToastController, Events } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()

export class ToastServiceProvider {
    constructor(
        public events: Events,
        public toastCtrl: ToastController,
        public translate: TranslateService

    ) {

    }
    /**
     * method create toast sederhana
     * @param message
     * @param duration
     * @param position
     */
    create(message: string, duration: number, position: string, closeButton: boolean = true) {
        return new Promise((resolve) => {
            const toast = this.toastCtrl.create({
                message: this.translate.instant(message),
                duration: duration,
                closeButtonText: 'OK',
                position: position,
                cssClass: "custom-toast"
            });

            if (closeButton) {
                toast.setShowCloseButton(true);
            }

            toast.present();

            toast.onDidDismiss(() => {
                resolve(true);
            });

            setTimeout(() => {
                resolve(true);
            }, duration)
        })
    }

    /**
     * method create dengan options tambahan
     * @param message
     * @param duration
     * @param position
     * @param cssClass
     * @param showCloseButton
     * @param closeButtonText
     * @param dismissOnPageChange
     */
    createAdv(message: string, duration: number, position: string, cssClass: string, showCloseButton: boolean, closeButtonText: string, dismissOnPageChange: boolean) {
        const toast = this.toastCtrl.create({
            message: this.translate.instant(message),
            duration: duration,
            position: position,
            cssClass: cssClass,
            showCloseButton: showCloseButton,
            closeButtonText: closeButtonText,
            dismissOnPageChange: dismissOnPageChange
        });
        toast.present();
    }

    /**
    * method create toast sederhana
    * @param message
    * @param duration
    * @param position
    */
    createToastCallback(message: string, duration: number, position: string, callback) {
        const toast = this.toastCtrl.create({
            message: this.translate.instant(message),
            duration: duration,
            position: position,
        });
        toast.present();
        toast.onDidDismiss(() => {
            callback();
        })
    }

    /**
* method create toast sederhana
* @param message
* @param duration
* @param position
*/
    // Custom Toast Standard
    createToastCustom(message: string, duration: number, position: string) {
        return new Promise((resolve) => {
            const toast = this.toastCtrl.create({
                message: this.translate.instant(message),
                duration: duration,
                position: position,
                cssClass: "custom-toast"
            });
            toast.present();
            toast.onDidDismiss(() => {
                resolve(true);
            });

            setTimeout(() => {
                resolve(true);
            }, duration);
        })
    }

    createHint(title: string, desc: string, ctaLabel: string, duration: number = null, ctaClose:boolean = false) {
        return new Promise((resolve) => {
            const data = {
                title: title,
                desc: desc,
                ctaLabel: ctaLabel,
                duration: duration,
                ctaClose: ctaClose
            }
            this.events.publish('toastCreate', data);

            this.events.subscribe('toastCallback', (result) => {
                resolve(true);
            })
        })
    }

}



// WEBPACK FOOTER //
// ./src/providers/toast-service/toast.service.ts